module.exports = __webpack_public_path__ + "img/moGaoKu1.416729db.png";